import {all, fork, put, takeEvery} from "redux-saga/effects";
import {getType} from "typesafe-actions";
import {enterCardsGame} from "./actions";
import {loadScene} from "../../routing/actions";

function* watchEnterMiniGame() {
    yield takeEvery(getType(enterCardsGame), function* () {
        yield put(loadScene.request('CardsMiniGame'));
    });
}

export default function* cardsGameSaga() {
    yield all([
        fork(watchEnterMiniGame),
    ]);
}